import React from 'react';
import Devices, { defaultConfigComponent as DeviceConfig } from './Devices';
import { IConfigComponent } from '@ts/ui-models';

export const defaultConfigComponent = (): IConfigComponent => {
  return {
    ...DeviceConfig(),
    componentId: 'devicesPassive',
    filtersFetchData: {
      device: { isAlive: true },
      deviceType: { isAlive: true },
      deviceTypeCategories: { isAlive: true },
      category: { logicalId: 'passive', isAlive: true },
    },
  };
};
const DevicesPassive = props => {
  const defaultProps = {
    title: 'Passive devices',
  };

  return <Devices configComponent={defaultConfigComponent()} {...defaultProps} {...props} />;
};

export default DevicesPassive;
